import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import ApiClient from "helpers/ApiClient";
interface IInitialState {
    status: string;
    paymentDetails: {
        invoiceNumber: string,
        invoiceDate: string,
        paymentTye: string,
        amount: number,
        vehicleNumber: string,
        user: any,
        serviceType: string
    };
    error: null;
    message: string;
}

const initialState: IInitialState = {
    status: "",
    paymentDetails: {
        invoiceNumber: "",
        invoiceDate: "",
        paymentTye: "",
        amount: 0,
        vehicleNumber: "",
        user: {},
        serviceType: ""
    },
    error: null,
    message: ""
}

export const postPaymentData = createAsyncThunk<IInitialState, { paymentMethodId: string, amount: number, vehicleId: string, vehicleNumber: string,pcnId:string }>(
    "type/postPaymentData",
    async (paymentDetails, thunkAPI) => {
        try {
            const response = await ApiClient.post("payment/pay-pcn", paymentDetails);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error)
        }
    }
);
const paymentSlice = createSlice({
    name: "paymentSlice",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(
            postPaymentData.pending,
            (state) => {
                state.status = "";
            }
        );
        builder.addCase(
            postPaymentData.fulfilled,
            (state, action: PayloadAction<any>) => {
                state.status = "succeeded";
                const paymentDetails = {
                    invoiceNumber: action.payload.data?.invoiceNumber,
                    invoiceDate: action.payload.data?.invoiceDate,
                    paymentTye: action.payload.data?.method,
                    amount: action.payload.data?.amount,
                    vehicleNumber: action.payload.data?.vehicleNumber,
                    user: action.payload.data?.User,
                    serviceType: action.payload.data?.service
                }
                state.paymentDetails = paymentDetails;
            }
            
        );
        builder.addCase(
            postPaymentData.rejected,
            (state,action:any) => {
                state.status = "failed";
                state.message = action?.payload?.response?.data?.message;
            }
        );
    },
})

export default paymentSlice;
